export const NU0 = 376.730313668; // impedance of free space Z0

export default { NU0 };



// WEBPACK FOOTER //
// ./src/constants/math.js